<template>
  <v-dialog
    v-model="show"
    max-width="500px"
    scrollable
    persistent
  >
    <v-card :loading="formProcessing">
      <v-card-title>
        <span class="headline">{{ formTitle }}</span>
      </v-card-title>

      <v-card-text>
        <v-container>
          <v-form>
            <v-row>
              <v-col
                cols="12"
                md="12"
              >
                <v-text-field
                  v-model="ip"
                  required
                  label="IP Address"
                  :error-messages="ipErrors"
                  @input="v$.ip.$touch()"
                  @blur="v$.ip.$touch()"
                />
              </v-col>
              <v-col
                cols="12"
                md="12"
              >
                <v-textarea
                  v-model="description"
                  required
                  label="Description"
                  :error-messages="descriptionErrors"
                  @input="v$.description.$touch()"
                  @blur="v$.description.$touch()"
                />
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer />

        <v-btn
          color="blue darken-1"
          text
          :disabled="formProcessing"
          @click="close()"
        >
          Cancel
        </v-btn>

        <v-btn
          color="blue darken-1"
          text
          :disabled="formProcessing"
          @click="save()"
        >
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex';
import { useVuelidate } from '@vuelidate/core';
import { required, maxLength, ipAddress } from '@vuelidate/validators';

export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    editedItem: {
      type: Object,
      default() {
        return {
          id: null,
          ip: '',
          description: '',
        };
      },
    },
  },
  setup() { return { v$: useVuelidate() }; },
  data() {
    return {
      id: null,
      ip: '',
      description: '',
      formProcessing: false,
    };
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    formTitle() {
      const newOrUpdate = this.isNewItem ? 'New' : 'Update';
      return `${newOrUpdate} Allowed Ip Address`;
    },
    isNewItem() {
      return !this.editedItem.id;
    },
    ipErrors() {
      const errors = [];

      if (!this.v$.ip.$dirty) {
        return errors;
      }
      if (this.v$.ip.required.$invalid) {
        errors.push('IP Address is required.');
      }
      if (this.v$.ip.maxLength.$invalid) {
        errors.push(`IP address must not exceed ${this.v$.ip.$params.maxLength.max} letters.`);
      }
      if (this.v$.ip.ipAddress.$invalid) {
        errors.push('Invalid IP address.');
      }

      return errors;
    },
    descriptionErrors() {
      const errors = [];

      if (!this.v$.description.$dirty) {
        return errors;
      }
      if (this.v$.description.maxLength.$invalid) {
        errors.push(`Description must not exceed ${this.v$.description.$params.maxLength.max} letters.`);
      }

      return errors;
    },
  },
  watch: {
    editedItem() {
      this.id = this.editedItem.id;
      this.ip = this.editedItem.ip;
      this.description = this.editedItem.description;
    },
  },
  methods: {
    ...mapActions('notification', ['setNotification']),

    save() {
      this.v$.$touch();

      if (!this.v$.$invalid) {
        this.formProcessing = true;
        let request = '';

        const data = {
          ip: this.ip,
          description: this.description,
        };

        if (this.isNewItem) {
          request = this.$axios.post('/api/v1/user-ip', data);
        } else {
          request = this.$axios.put(`/api/v1/user-ip/${this.editedItem.id}`, data);
        }

        request
          .then((res) => {
            this.$emit('item-saved');

            this.setNotification({
              message: `${res.data.ip} has been saved.`,
              color: 'green',
            });
          })
          .catch(() => {
            this.setNotification({
              message: 'There was an error processing your request.',
              color: 'red',
            });
          })
          .then(() => {
            this.formProcessing = false;

            this.close();
          });
      }
    },
    close() {
      this.v$.$reset();

      this.ip = '';
      this.description = '';
      this.$emit('close-modal');
    },
  },
  validations: {
    ip: {
      required,
      maxLength: maxLength(45),
      ipAddress,
    },
    description: {
      maxLength: maxLength(250),
    },
  },
};
</script>

<style></style>
